// Currency formatting utility with multi-currency support

export type Currency = 'INR' | 'USD' | 'EUR' | 'GBP' | 'AUD' | 'CAD';

const currencyConfig: Record<Currency, { locale: string; symbol: string }> = {
  INR: { locale: 'en-IN', symbol: '₹' },
  USD: { locale: 'en-US', symbol: '$' },
  EUR: { locale: 'de-DE', symbol: '€' },
  GBP: { locale: 'en-GB', symbol: '£' },
  AUD: { locale: 'en-AU', symbol: 'A$' },
  CAD: { locale: 'en-CA', symbol: 'C$' },
};

export function formatCurrency(amount: number | string, currency: Currency = 'USD'): string {
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  const config = currencyConfig[currency] || currencyConfig.USD;
  
  return new Intl.NumberFormat(config.locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numAmount);
}

export function formatCurrencyCompact(amount: number | string, currency: Currency = 'USD'): string {
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  const config = currencyConfig[currency] || currencyConfig.USD;
  return `${config.symbol}${numAmount.toFixed(2)}`;
}

// Legacy support - defaults to INR for backward compatibility
export function formatINR(amount: number | string): string {
  return formatCurrency(amount, 'INR');
}

export function formatINRCompact(amount: number | string): string {
  return formatCurrencyCompact(amount, 'INR');
}

// Get currency symbol
export function getCurrencySymbol(currency: Currency = 'USD'): string {
  return currencyConfig[currency]?.symbol || '$';
}
